import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AdminPanel from './components/AdminPanel';
import UserPanel from './components/UserPanel';
import LoginForm from './components/LoginForm';
import ApplicationPeriodsSection from './components/ApplicationPeriodsSection';
import { ToastProvider } from './context/ToastContext';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import './App.css';
import './components/AboutSection.css';

function AppContent() {
  const { t } = useLanguage();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const adminToken = localStorage.getItem('adminToken');
    const adminUser = localStorage.getItem('adminUser');
    const userToken = localStorage.getItem('userToken');
    const userData = localStorage.getItem('userData');
    
    if (adminToken && adminUser) {
      setIsAuthenticated(true);
      setUserType('admin');
    } else if (userToken && userData) {
      setIsAuthenticated(true);
      setUserType('user');
    }
    setIsLoading(false);
  }, []);

  // Check routes
  const isAdminRoute = window.location.pathname === '/admin';
  const isUserRoute = window.location.pathname === '/user';
  
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{ color: 'white', fontSize: '1.2rem' }}>Loading...</div>
      </div>
    );
  }
  
  if (isAdminRoute) {
    if (isAuthenticated && userType === 'admin') {
      return (
        <LanguageProvider>
          <ToastProvider>
            <AdminPanel />
          </ToastProvider>
        </LanguageProvider>
      );
    } else {
      return (
        <LanguageProvider>
          <ToastProvider>
            <LoginForm />
          </ToastProvider>
        </LanguageProvider>
      );
    }
  }
  
  if (isUserRoute) {
    if (isAuthenticated && userType === 'user') {
      return (
        <LanguageProvider>
          <ToastProvider>
            <UserPanel />
          </ToastProvider>
        </LanguageProvider>
      );
    } else {
      return (
        <LanguageProvider>
          <ToastProvider>
            <LoginForm />
          </ToastProvider>
        </LanguageProvider>
      );
    }
  }

  return (
    <div className="App">
        <Navbar />
        <HeroSection />
      
      {/* Funding Options Section */}
      <section id="funding" className="section">
        <div className="container">
          <h2 className="section-title">Funding Options</h2>
          <div className="funding-grid">
            <div className="funding-card">
              <div className="card-icon">💰</div>
              <h3>Personal Loans</h3>
              <p>Quick and easy personal financing for your immediate needs</p>
            </div>
            <div className="funding-card">
              <div className="card-icon">🏢</div>
              <h3>Business Funding</h3>
              <p>Grow your business with our flexible funding solutions</p>
            </div>
            <div className="funding-card">
              <div className="card-icon">🎓</div>
              <h3>Education Loans</h3>
              <p>Invest in your future with our education financing</p>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section id="how-it-works" className="section">
        <div className="container">
          <h2 className="section-title">How it Works</h2>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Apply Online</h3>
              <p>Fill out our simple online application form</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Get Approved</h3>
              <p>Quick approval process within 24 hours</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Receive Funds</h3>
              <p>Get your funds directly in your account</p>
            </div>
          </div>
        </div>
      </section>



      {/* Application Periods & Results Section */}
      <ApplicationPeriodsSection />

      {/* Blog Section */}
      <section id="blog" className="section">
        <div className="container">
          <h2 className="section-title">Latest from Our Blog</h2>
          <div className="blog-grid">
            <article className="blog-card">
              <div className="blog-image"></div>
              <div className="blog-content">
                <h3>Financial Planning Tips</h3>
                <p>Essential strategies for better financial management</p>
                <span className="blog-date">March 15, 2024</span>
              </div>
            </article>
            <article className="blog-card">
              <div className="blog-image"></div>
              <div className="blog-content">
                <h3>Investment Opportunities</h3>
                <p>Discover the best investment options for 2024</p>
                <span className="blog-date">March 10, 2024</span>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="section">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="faq-container">
            <div className="faq-item">
              <h3>What documents do I need to apply?</h3>
              <p>You'll need proof of identity, income, and address. We'll guide you through the process.</p>
            </div>
            <div className="faq-item">
              <h3>How long does approval take?</h3>
              <p>Most applications are approved within 24 hours of submission.</p>
            </div>
            <div className="faq-item">
              <h3>What are the interest rates?</h3>
              <p>Our rates are competitive and vary based on your credit profile and loan type.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Vikas Fund</h3>
              <p>Empowering dreams through innovative funding solutions</p>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#funding">Funding Options</a></li>
                <li><a href="#how-it-works">How it Works</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#blog">Blog</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>Email: info@vikasfund.com</p>
              <p>Phone: +1 (555) 123-4567</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Vikas Fund. All rights reserved.</p>
          </div>
        </div>
      </footer>
      </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </LanguageProvider>
  );
}

export default App;
